module.exports = __webpack_public_path__ + "static/img/img_cabinet.c2365fda.png";